import { Grid, Modal, Paper, Typography } from '@mui/material';
import { asDateWithTimezone } from '../../util/DateFormat';

export default function PatientInfo(props) {
  const patient = props.patient;

  return (
    patient && (
      <Modal open={props.open} onClose={props.handleClosePatient}>
        <Paper
          sx={{
            padding: '32px',
            position: 'absolute',
            minWidth: '350px',
            maxWidth: '500px',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography
                component="h3"
                sx={{
                  fontSize: '1.5em',
                  textAlign: 'center',
                  marginBottom: '8px',
                }}
              >
                Patient Details
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Name</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.name}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Age</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.age}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Gender</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.sex}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Enthnicity</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.ethnicity}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography
                component="h5"
                sx={{
                  fontSize: '1.5em',
                  textAlign: 'center',
                  marginBottom: '8px',
                }}
              >
                Medical History
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Suffered Stroke</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.sufferedStroke ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Prior Stroke</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.priorStroke}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Date of symptoms onset</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.symptomsOnset ? asDateWithTimezone(patient.medicalHistory.symptomsOnset) : '[not set]'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Hypertension</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.hypertension ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Diabetes Mellitus</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.diabetesMellitus ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Hyperlipidemia</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.hyperlipidemia ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Smoker</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.smoker ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Atrial Fibrillation</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.atrialFibrillation ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Coronary Artery Disease</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.coronaryArteryDisease ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Heart Failure</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.heartFailiure ? 'YES' : 'NO'}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography>Obesity</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ textAlign: 'right' }}>{patient.medicalHistory.obesity ? 'YES' : 'NO'}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    )
  );
}
